module.exports = __webpack_public_path__ + "static/media/GoogleStore.13f0dc71.png";